<template>
    <div class="navbar">
        <LogOutDialog
            v-if="LogOutDialog"
            :LogOutDialog="LogOutDialog"
            @closeHandleDialog="closeHandleDialog"
        />
        <v-app-bar class="sd">
            <figure class="logo">
                <router-link to="/dashboard"
                    ><img class = "companyLogo" src="/img/p2pLogo.png" alt="IndiaP2P"
                /></router-link>
            </figure>
            <v-spacer></v-spacer>
            <div class="navMenu" v-if="!$route.meta.hideNavData">
                <ul class="menuList">
                    <!-- <div v-if="!$route.meta.showOnlyLogout && !hideReferralCode" class = "newFeatureContainer">
                        <span class="btn-shine" >New</span>
                        <span class="btn-shine" >Feature</span>
                    </div> -->
                    <div v-if="!$route.meta.showOnlyLogout && !hideReferralCode" class = "escrowContainer mr-30" @click = "escrowWalletDialogBox">
                        <p class = "escrowText">
                            <v-icon class="material-icons-round bannerIcons mr-5">
                                account_balance_wallet
                            </v-icon>
                            &#x20B9;{{escrowBalance | localeAmount}}
                        </p>
                    </div>
                    <v-menu
                        bottom
                        :rounded="true"
                        v-model="dropdown1"
                        :close-on-content-click="false"
                        transition="slide-y-transition"
                        v-if="$route.path == '/onboarding'"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon
                                class="material-icons-round logoutIcon"
                                v-bind="attrs"
                                v-on="on"
                            >
                                more_vert
                            </v-icon>
                        </template>
                        <v-list>
                            <span></span>
                            <v-list-item
                                @click="navbarBankAccountDetails"
                                title="Bank & Account Details"
                                v-if="currentStep == 5 || currentStep == 6 || currentStep == 7"
                            >
                                <v-icon
                                    class="material-icons-round logoutIcon"
                                    >account_balance</v-icon
                                >Bank & Account Details
                            </v-list-item>
                            <v-list-item target="_blank" href="https://www.indiap2p.com/blogs">
                                <a
                                    v-if="$route.path == '/onboarding'"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >rss_feed</v-icon
                                    >
                                    Blog
                                </a>
                            </v-list-item>
                            <v-list-item target="_blank" href="https://www.indiap2p.com/faqs">
                                <a
                                    v-if="$route.path == '/onboarding'"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >info</v-icon
                                    >
                                    FAQs
                                </a>
                            </v-list-item>
                            <v-list-item
                                target="_blank"
                                href="https://wa.me/+919076284367"
                                v-if="$route.path == '/onboarding'"
                                title="Contact Us"
                            >
                                <a>
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >whatsapp</v-icon
                                    >
                                    Contact Us
                                </a>
                            </v-list-item>
                            <hr />
                            <v-list-item
                                class="mt-2"
                                v-if="$route.path == '/onboarding'"
                                @click="logout"
                            >
                                <v-icon class="material-icons-round logoutIcon"
                                    >logout</v-icon
                                >
                                <span> Logout </span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <li class="profile" v-if="$route.meta.showLogout">
                        <v-menu
                            bottom
                            :rounded="true"
                            v-model="dropdown"
                            :close-on-content-click="false"
                            transition="slide-y-transition"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <figure
                                    v-bind="attrs"
                                    v-on="on"
                                    class="profileImage"
                                    v-if="!$route.meta.showOnlyLogout"
                                >
                                    <img
                                        v-if="profileImage"
                                        :src="profileImage"
                                        alt=""
                                    />
                                    <span class="initials" v-else>{{
                                        name | formatName()
                                    }}</span>
                                </figure>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    class="mb-2"
                                >
                                    <div class="figure">
                                        <figure
                                            v-if="profileImage"
                                            class="profileImage"
                                        >
                                            <img :src="profileImage" alt="" />
                                        </figure>
                                        <span class="initials" v-else>{{
                                            name | formatName()
                                        }}</span>
                                    </div>
                                    <div>{{ name }}!</div>
                                </v-list-item>
                                <hr />
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="nomineeDialog"
                                    title="Nominee"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >person</v-icon
                                    >
                                    Nominee
                                </v-list-item>
                                <!-- <v-list-item
                                    v-if="
                                        !$route.meta.showOnlyLogout &&
                                            !hideReferralCode
                                    "
                                    @click="withdrawalDialog"
                                    title="Withdraw"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >payments</v-icon
                                    >Withdraw
                                </v-list-item> -->
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="bankAccountDetails"
                                    title="Bank & Account Details"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >account_balance</v-icon
                                    >Bank & Account Details
                                </v-list-item>
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="transactionHistory"
                                    title="Transaction History"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >history</v-icon
                                    >Transaction History
                                </v-list-item>
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="reportsPage"
                                    title="Reports"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >insert_chart</v-icon
                                    >Reports
                                </v-list-item>
                                <v-list-item target="_blank" href="https://www.indiap2p.com/blogs">
                                    <a
                                        v-if="!$route.meta.showOnlyLogout"
                                    >
                                        <v-icon
                                            class="material-icons-round logoutIcon"
                                            >rss_feed</v-icon
                                        >
                                        <span>Blog</span>
                                    </a>
                                </v-list-item>
                                <v-list-item target="_blank" href="https://www.indiap2p.com/faqs">
                                    <a
                                        v-if="!$route.meta.showOnlyLogout"
                                    >
                                        <v-icon
                                            class="material-icons-round logoutIcon"
                                            >info</v-icon
                                        >FAQs
                                    </a>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                        !$route.meta.showOnlyLogout &&
                                            !hideReferralCode
                                    "
                                    @click="shareReferral"
                                    title="Share Referral Code"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >share</v-icon
                                    >Referral Code ({{generatedReferralCode}})
                                </v-list-item>
                                <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="settingsPage"
                                    title="Settings"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >settings</v-icon
                                    >Settings
                                </v-list-item>
                                <v-list-item
                                    title="Contact Us"
                                    target="_blank"
                                    href="https://wa.me/+919076284367"
                                >
                                    <a
                                        class = "whatsappIcons"
                                    >
                                    <img src="/img/whatsapp.svg" class = "mr-20">Contact Us
                                    </a>
                                </v-list-item>
                                <hr />
                                <v-list-item class="mt-2" @click="logout">
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >logout</v-icon
                                    >
                                    <span> Logout </span>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </li>
                </ul>
            </div>
            <!-- <div v-if="!$route.meta.hideNavData && !$route.meta.showOnlyLogout && !hideReferralCode" class = "mobileContainer">
                <span class="btn-shine" >New</span>
                <span class="btn-shine" >Feature</span>
            </div> -->
            <div v-if="!$route.meta.hideNavData && !$route.meta.showOnlyLogout && !hideReferralCode" class = "escrowContainerMobile mr-30" @click = "escrowWalletDialogBox">
                <p class = "escrowText">
                    <v-icon class="material-icons-round bannerIcons mr-5">
                        account_balance_wallet
                    </v-icon>
                    &#x20B9;{{escrowBalance | localeAmount}}</p>
            </div>
            <button
                @click="drawer = !drawer"
                class="sidebar"
                v-if="!$route.meta.hideNavData"
            >
                <v-icon class="menuIcon theme--light"> fas fa-bars </v-icon>
            </button>
        </v-app-bar>

        <div class="sidebar">
            <v-navigation-drawer v-model="drawer" absolute right temporary>
                <button @click="drawer = false" class="closeButton">
                    <v-icon class="material-icons-round logoutIcon"
                        >close
                    </v-icon>
                </button>
                <v-list nav dense>
                    <v-list-item-group v-model="group">
                        <v-list-item v-if="$route.meta.showLogout">
                            <div
                                class="figure"
                                v-if="!$route.meta.showOnlyLogout"
                            >
                                <figure class="profileImage">
                                    <img
                                        v-if="profileImage"
                                        :src="profileImage"
                                        alt=""
                                    />
                                    <span class="initials mr-2" v-else>{{
                                        name | formatName()
                                    }}</span>
                                </figure>
                            </div>
                            <div v-if="!$route.meta.showOnlyLogout">
                                {{ name }}!
                            </div>
                        </v-list-item>
                        <v-list-item
                            @click="navbarBankAccountDetails"
                            title="Bank & Account Details"
                            v-if="(currentStep == 5 || currentStep == 6 || currentStep == 7) && $route.meta.showLogout"
                        >
                            <v-icon
                                class="material-icons-round logoutIcon"
                                >account_balance</v-icon
                            >Bank & Account Details
                        </v-list-item>
                        <v-list-item
                            v-if="!$route.meta.showOnlyLogout"
                            @click="nomineeDialog"
                            title="Nominee"
                        >
                            <v-icon class="material-icons-round logoutIcon">person</v-icon>Nominee
                        </v-list-item>
                        <!-- <v-list-item
                            v-if="
                                !$route.meta.showOnlyLogout && !hideReferralCode
                            "
                            @click="withdrawalDialog"
                            title="Withdraw"
                        >
                            <v-icon class="material-icons-round logoutIcon"
                                >payments</v-icon
                            >Withdraw
                        </v-list-item> -->
                        <v-list-item
                            v-if="!$route.meta.showOnlyLogout"
                            @click="bankAccountDetails"
                            title="Bank & Account Details"
                        >
                            <v-icon
                                class="material-icons-round logoutIcon"
                                >account_balance</v-icon
                            >Bank & Account Details
                        </v-list-item>
                        <v-list-item
                                    v-if="!$route.meta.showOnlyLogout"
                                    @click="transactionHistory"
                                    title="Transaction History"
                                >
                                    <v-icon
                                        class="material-icons-round logoutIcon"
                                        >history</v-icon
                                    >Transaction History
                        </v-list-item>
                        <v-list-item
                            v-if="!$route.meta.showOnlyLogout"
                            @click="reportsPage"
                            title="Reports"
                        >
                            <v-icon
                                class="material-icons-round logoutIcon"
                                >insert_chart</v-icon
                            >Reports
                        </v-list-item>
                        <v-list-item target="_blank" href="https://www.indiap2p.com/blogs">
                            <a
                                v-if="$route.meta.showLogout"
                            >
                                <v-icon class="material-icons-round logoutIcon"
                                    >rss_feed</v-icon
                                >
                                Blog
                            </a>
                        </v-list-item>
                        <v-list-item target="_blank" href="https://www.indiap2p.com/faqs">
                            <a
                                v-if="$route.meta.showLogout"
                            >
                                <v-icon class="material-icons-round logoutIcon"
                                    >info</v-icon
                                >
                                FAQs
                            </a>
                        </v-list-item>
                        <v-list-item
                            @click="shareReferral"
                            title="Share Referral Code"
                            v-if="
                                !$route.meta.showOnlyLogout && !hideReferralCode
                            "
                        >
                            <v-icon class="material-icons-round logoutIcon"
                                >share</v-icon
                            >
                            <p>Referral Code ({{generatedReferralCode}})</p>
                        </v-list-item>
                        <v-list-item
                            v-if="!$route.meta.showOnlyLogout"
                            @click="settingsPage"
                            title="Settings"
                        >
                            <v-icon class="material-icons-round logoutIcon"
                                >settings</v-icon
                            >
                            Settings
                        </v-list-item>
                        <v-list-item title="Contact Us" target="_blank" href="https://wa.me/+919076284367">
                            <a
                                v-if="$route.meta.showLogout"
                                class = "whatsappIcons"
                            >
                            <img src="/img/whatsapp.svg" class = "mr-20">Contact Us
                            </a>
                        </v-list-item>
                        <v-list-item
                            @click="logout"
                            v-if="$route.meta.showLogout"
                        >
                            <v-icon class="material-icons-round logoutIcon"
                                >logout</v-icon
                            >
                            <span> Logout </span>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
        </div>
        <!-- <escrowInvestDialog
            v-if="showEscrowInvestDialog"
            :showEscrowInvestDialog="showEscrowInvestDialog"
            :escrowBalance = "escrowBalance"
            :incomeAmount = "incomeAmount"
            @closeDialog="closeEscrowDialog"
        /> -->
        <escrowWalletDialog
            v-if="showEscrowWalletDialog"
            :showEscrowWalletDialog="showEscrowWalletDialog"
            :escrowBalance = "escrowBalance"
            :incomeAmount = "incomeAmount"
            @closeDialog="closeEscrowWalletDialog"
        />
        <v-snackbar v-model="isCopied" app timeout="8000">
            Copied to clipboard!

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isCopied = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { bus } from '@/main'
import LogOutDialog from '../logOutDialog.vue'
// import escrowInvestDialog from '@/components/common/escrowInvestDialog.vue'
import escrowWalletDialog from '@/components/common/escrowWalletDialog.vue'

export default {
    name: 'Navbar',
    components: {
        LogOutDialog,
        // escrowInvestDialog,
        escrowWalletDialog
    },
    data: () => ({
        drawer: false,
        dropdown: false,
        dropdown1: false,
        isCopied: false,
        group: null,
        profileImage: '/img/profile.jpg',
        generatedReferralCode: null,
        name: '',
        hideReferralCode: false,
        LogOutDialog: false,
        escrowBalance: 0,
        incomeAmount: 0,
        // showEscrowInvestDialog: false,
        showEscrowWalletDialog: false
        // showBankDetails: false
    }),
    computed: {
        currentStep () {
            console.log('this.$store.state.onBoarding.step', this.$store.state.onBoarding.step)
            return this.$store.state.onBoarding.step
        }
    },
    watch: {
        group () {
            this.drawer = false
        },
        '$store.state.hideReferralCode': {
            handler (newValue, oldValue) {
                this.hideReferralCode = newValue
            },
            deep: true,
            immediate: true
        },
        '$store.state.dashboard.profileImage': {
            handler (newValue, oldValue) {
                this.profileImage = this.$store.state.dashboard.profileImage
            },
            deep: true,
            immediate: true
        },
        '$store.state.dashboard.accountInfo': {
            handler (newValue, oldValue) {
                if (this.$route.meta.showDashboard && newValue !== undefined && newValue !== null) {
                    this.escrowBalance = this.$store.getters['dashboard/getChartDetails'].escrowBalance
                    this.incomeAmount = this.$store.getters['dashboard/getChartDetails'].incomeAmount
                }
            },
            deep: true,
            immediate: true
        }
    },
    filters: {
        formatName (string) {
            const names = string.split(' ')
            const initials = names[0].substring(0, 1).toUpperCase()
            return initials
        }
    },
    mounted () {
        this.name =
            this.$store.state.userName || this.$store.state.onBoarding.Name
        this.profileImage = this.$store.state.dashboard.profileImage
        this.generatedReferralCode = this.$store.state.dashboard.generatedReferralCode
    },
    methods: {
        // closeEscrowDialog () {
        //     this.showEscrowInvestDialog = false
        // },
        // escrowDialogBox () {
        //     if ((this.escrowBalance - this.incomeAmount) >= 500) {
        //         this.showEscrowInvestDialog = true
        //     }
        // },
        closeEscrowWalletDialog () {
            this.showEscrowWalletDialog = false
        },
        escrowWalletDialogBox () {
            if (this.escrowBalance >= 0 || this.incomeAmount >= 0) {
                this.showEscrowWalletDialog = true
            }
        },
        transactionHistory () {
            this.$router.push('/transactions')
        },
        bankAccountDetails () {
            this.$router.push('/bankAccountDetails')
        },
        navbarBankAccountDetails () {
            console.log('hollaaaaaaaaaa')
            // this.$router.push('/bankAccountDetails')
            this.$store.dispatch('onBoarding/setField', { field: 'showBankDetails', value: !this.$store.state.onBoarding.showBankDetails })
            // this.showBankDetails = true
        },
        closeHandleDialog () {
            this.LogOutDialog = false
        },
        shareReferral () {
            navigator.clipboard.writeText(
                `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
            )
            this.isCopied = true
            if (navigator.share) {
                // Web Share API is supported
                navigator
                    .share({
                        title: 'IndiaP2P Invest',
                        text:
                            'Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=' +
                            this.generatedReferralCode
                    })
                    .then(() => {
                    })
            } else {
                // Fallback
                navigator.clipboard
                    .writeText(
                        `Join me to invest in loans curated by IndiaP2P and earn up to 18% returns on your investments. IndiaP2P is an RBI certified NBFC- P2P. Create your account using this link here: https://invest.indiap2p.com/register?ref=${this.generatedReferralCode}`
                    )
                    .then(() => {
                        this.isCopied = true
                    })
            }
        },
        withdrawalDialog () {
            bus.$emit('withdrawDialog', 'withdraw dialog')
        },
        nomineeDialog () {
            bus.$emit('nomineeDialog', 'nominee dialog')
        },
        settingsPage () {
            this.$router.push('/settings')
        },
        reportsPage () {
            this.$router.push('/reports')
        },
        closeDropdown () {
            this.dropdown = false
            this.dropdown1 = false
        },
        logout () {
            if (this.$route.path === '/onboarding') {
                this.$store.dispatch('logout')
                this.$router.push('/login')
            } else {
                this.LogOutDialog = true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./navbar.scss";

.newFeatureContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.btn-shine {
  padding-right: 12px;
  color: #ffffff;
  background: linear-gradient(45deg, #8c8c8c, #0c0c2d, #002fa7);
  background-position: 0;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shine 3s infinite linear;
  animation-fill-mode: forwards;
  -webkit-text-size-adjust: none;
  font-weight: 600;
  font-size: 10px;
  text-decoration: none;
  white-space: nowrap;
}
@keyframes shine {
  0% {
    background-position: 0
  }
  60% {
    background-position: 180px
  }
  100% {
    background-position: 180px
  }
}
.escrowContainer:before, .escrowContainer:after, .escrowContainerMobile:after, .escrowContainerMobile:before {
    content: '';
    position: absolute;
    left: -2px;
    top: -2px;
    background: linear-gradient(45deg, #002fa7, #c0c0c0,#ffff00,
    #002fa7, #c0c0c0,#ffff00);
    background-size: 150%;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    z-index: -1;
    animation: steam 10s linear infinite;
}

@keyframes steam {
    0% {
        background-position: 0 0;
    }
    50% {
        background-position: 100% 0;
    }
    100% {
        background-position: 0 0;
    }
}

.escrowContainer:after, .escrowContainerMobile:after{
    filter: blur(50px);
}
.bannerIcons {
        font-size: 20px !important
    }
.escrowContainer {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-width: 80px;
    border-radius: 0px;
    background: #F2F6FF;
    padding: 5px
}
.escrowContainerMobile {
    position: relative;
    display: none
}
.mobileContainer {
    position: relative;
    display: none
}
.escrowText {
    font-weight: 700;
    font-size: 13px;
    color: #232323;
}
.whatsappIcons {
    display: flex
}
.v-application p {
    margin-bottom: 0px;
}

a {
    color: #020067 !important;
    font-weight: 500;
}

.icons {
    height: 24px;
    width: 21px;
    margin-right: 20px;
    margin-left: 8px;
    color: #4f4f4f !important;
}

.selectedNavItem {
    background-color: #4f4f4f !important;
    border-radius: 0px !important;
}

.profile {
    display: flex;
    margin-right: 18px;
}
.profileImage {
    margin-right: 12px;
    img {
        width: 38px;
        height: 38px;
        border-radius: 50%;
    }
}
.initials {
    display: inline-block;
    background-color: #acbeff;
    border-radius: 50%;
    color: white;
    padding-top: 12%;
    width: 32px;
    height: 32px;
    margin-right: 16px;
    text-align: center;
    font-size: 14px;
    font-weight: normal;
}
.closeButton {
    position: absolute;
    left: 90%;
    top: 8px;
}

.logoutIcon {
    color: #4f4f4f !important;
    margin-right: 20px;
    width: 24px !important;
    height: 24px !important;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #4f4f4f !important;
    font-weight: 500;

    &:hover:not(.v-list-item:nth-child(-n + 1)) {
        cursor: pointer;
        background: rgba(2, 0, 103, 0.07);
    }
}

.fas.fa-chevron-up {
    position: absolute;
    left: calc(100% - 24px);
    top: 0;
    color: #020067;
    min-height: 12px !important;
}

.v-list-item:last-child {
    padding-bottom: 6px;
}
.v-list-item a {
    color: #4f4f4f !important;
}
.v-list-item__title {
    font-size: unset !important;
    font-weight: unset !important;
    line-height: unset !important;
}

a {
    text-decoration: none;
}
hr {
    height: 0px;
    border: 0.5px solid rgba(189, 189, 189, 0.3);
    opacity: 0.4;
}
.v-list {
    padding: 16px;
    width: 334px;
}

@media (max-width: 680px) {
    .mobileContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .escrowContainerMobile {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: center;
        min-width: 80px;
        border-radius: 0px;
        background: #F2F6FF;
        padding: 5px
    }
    .companyLogo {
        width: 100px
    }
}
</style>
